/**
 * Sales invoice document viewer — a thin wrapper over the shared
 * DocumentPrintPage with the invoice (customer-facing) configuration, which
 * lives in docPrintConfigs so the public `/d/:token` paper renders from the very
 * same object.
 */
import { INVOICE_DOC_CONFIG } from './docPrintConfigs.js';
import { DocumentPrintPage } from './DocumentPrintPage.js';

export function InvoicePrintPage(): JSX.Element {
  return <DocumentPrintPage config={INVOICE_DOC_CONFIG} />;
}
